// getMessageDataList.js
'use strict';
import { Collection } from 'immutable';
import { createSelector } from '../resource/createCachedSelector.js';

/**
 * Select message data list by message ids
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} messageIds=[] - message ids.
 * @param {bool} [needUnique=true] - should dedupe message ids
 * @return {array} The selected message data list.
 */
const getMessageDataList = createSelector(
  state => state.get('messages'),
  (state, messageIds) => messageIds || [],
  (state, messageIds, needUnique) => needUnique,
  (messages, messageIds, needUnique = true) => {
    let ids = messageIds;
    if (needUnique) {
      ids = [...new Set(messageIds)];
    }
    const result = ids
      .map(messageId => messages.get(messageId)?.toJS())
      .filter(a => a);
    return result instanceof Collection ? result.toJS() : result;
  }
);

export default getMessageDataList;
